import classNames from 'classnames';

import React from 'react';
import { FormattedMessage } from 'react-intl';

import FleetbackCampusIcon from 'ui/base/icons/campus-logo.svg';
import { b } from 'utils/i18nUtils';

import { WrapperContent, PopoverContent, PopoverFooter, IconHeart } from './UI';

/**
 * @typedef {{
 *  onFleetbackGuide: (event: MouseEvent) => void,
 *  name: string,
 * }} CampusContentProps
 */

/** @type {React.FC<CampusContentProps>} */
const CampusContent = ({ onFleetbackGuide, name }) => (
  <WrapperContent>
    <PopoverContent>
      <FormattedMessage id="about.fleetbackCampus" defaultMessage="Fleetback Campus" tagName="h3" />
      <p className="campusText">
        <FormattedMessage
          id="about.campusLink"
          defaultMessage="For the <b>faq, tutorials, webinars</b> and dedicated <b>support</b>, visit Fleetback Campus."
          values={{
            b,
          }}
        />{' '}
        <FormattedMessage
          id="about.campusLogin"
          defaultMessage="Use the same login as your fleetback account to access it."
        />
      </p>
      <a href="#campus" onClick={onFleetbackGuide} className="btn_campus" data-cy="link-campus">
        <FleetbackCampusIcon height="22" width="140" />
      </a>
    </PopoverContent>
    <PopoverFooter>
      <p>
        <a
          className="header-usernav__help--link d-flex align-items-center"
          href="https://www.fleetback.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FormattedMessage id="about.madeWith" defaultMessage="Made with" />
          <span className={classNames(IconHeart, 'fb-icon--heart text-base')} />{' '}
          <FormattedMessage id="about.byFleetback" defaultMessage="by {name}" values={{ name }} />
        </a>
      </p>
    </PopoverFooter>
  </WrapperContent>
);

export default CampusContent;
